import React from 'react';
import {
  Box,
} from '@mui/material';

function BackgroundImage({ src = 'https://www.westrentacar.com/images/slider/esp/desktop/banner4.jpg', sx={} }) {
  return (
    <Box
      component="img"
      sx={{
        height: 'auto',
        width: '100%',
        ...sx,
      }}
      alt="Main image"
      src={src}
    />
  );
}

export default BackgroundImage;
